module.exports = __webpack_public_path__ + "static/img/湖南银行照片反面横版.7322220.png";


//////////////////
// WEBPACK FOOTER
// ./static/hunanDIY/湖南银行照片反面横版.png
// module id = 2LJA
// module chunks = 24